<template>
  <header class="bg-grey px-5 md:px-10 py-10 md:py-13">
    <div class="max-w-300 mx-auto flex flex-col items-center gap-4 text-center">
      <LangRouterLink
        :to="returnRoute"
        class="flex items-center gap-2.5 text-(--main-color) font-semibold hover:text-(--accent-color) transition-colors"
      >
        <IconSprite id="arrow" class="rotate-180 text-[10px]" />
        <span>{{ returnLabel }}</span>
      </LangRouterLink>
      <h1 class="font-semibold text-4xl md:text-6xl">{{ title }}</h1>
    </div>
  </header>
</template>

<script lang="ts">
import { IconSprite, LangRouterLink } from "@/components/helpers";

export default {
  name: "ShowHeader",
  components: { IconSprite, LangRouterLink },
  props: {
    returnLabel: {
      type: String,
      required: true,
    },
    returnRoute: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
